import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'costSqFt'
})
export class CostSqFtPipe implements PipeTransform {
  transform(item: any): any {
    const d = item.dimensions;
    let sf = 0;
    if(d.length && d.width) {
      sf = (parseFloat(d.length) * parseFloat(d.width))/144;
    }
    if(sf > 0 && d.lShape.length && d.lShape.width) {
      //sf = sf - ((parseFloat(d.length) - parseFloat(d.lShape.length)) * (parseFloat(d.width) - parseFloat(d.lShape.width)));
      let sf2 = (parseFloat(d.lShape.length) *  parseFloat(d.lShape.height))/144;
      sf = sf-sf2;
    }

    if(sf > 0) {
      if(item.price.slab) {
        let slabP = item.price.slab?parseFloat(item.price.slab):0;
        let shipP = item.price.shipping?parseFloat(item.price.shipping):0;
        let tx = slabP * .06;
        let totalPrice = slabP + shipP + tx;

        return (totalPrice/sf).toFixed(2);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/cost-sq-ft-pipe.ts